!(function () {
  function e(e, n) {
    if (e) {
      if ("string" == typeof e) return t(e, n);
      var a = {}.toString.call(e).slice(8, -1);
      return (
        "Object" === a && e.constructor && (a = e.constructor.name),
        "Map" === a || "Set" === a
          ? Array.from(e)
          : "Arguments" === a ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
          ? t(e, n)
          : void 0
      );
    }
  }
  function t(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
    return a;
  }
  function n(e) {
    return (
      (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            }),
      n(e)
    );
  }
  function a(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      (a.enumerable = a.enumerable || !1),
        (a.configurable = !0),
        "value" in a && (a.writable = !0),
        Object.defineProperty(e, o(a.key), a);
    }
  }
  function i(e, t, n) {
    return (
      t && r(e.prototype, t),
      n && r(e, n),
      Object.defineProperty(e, "prototype", { writable: !1 }),
      e
    );
  }
  function o(e) {
    var t = (function (e, t) {
      if ("object" != n(e) || !e) return e;
      var a = e[Symbol.toPrimitive];
      if (void 0 !== a) {
        var r = a.call(e, "string");
        if ("object" != n(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(e);
    })(e);
    return "symbol" == n(t) ? t : t + "";
  }
  var s = function (e, t) {
      var n;
      return function () {
        var a = this,
          r = arguments;
        clearTimeout(n),
          (n = setTimeout(function () {
            return e.apply(a, r);
          }, t));
      };
    },
    c = (function () {
      return i(
        function e() {
          a(this, e);
        },
        [
          {
            key: "onDropdownMenuParentMouseLeave",
            value: function (e) {
              var t = e.target,
                n = t.querySelector(".header__mega-menu > .list-menu");
              this.isMouseOutOfBounds(e, t, n, 1) &&
                (this.resetMenuState(), this.activateFirstMegaMenu());
            },
          },
          {
            key: "isMouseOutOfBounds",
            value: function (e, t, n, a) {
              var r = e.clientX,
                i = e.clientY,
                o = t.getBoundingClientRect(),
                s = n.getBoundingClientRect(),
                c = o.left,
                l = o.right,
                u = o.top,
                d = o.bottom + a,
                m = s.left,
                h = s.right,
                v = s.top - a,
                f = s.bottom;
              return !(
                (r >= c && r <= l && i >= u && i <= d) ||
                (r >= m && r <= h && i >= v && i <= f)
              );
            },
          },
          {
            key: "resetMenuState",
            value: function () {
              this.removeClassFromElements(".dropdown-menu", "active"),
                this.removeClassFromElements(".header__mega-menu", "active"),
                this.addClassToElements(".header__mega-menu", "!hidden"),
                this.removeClassFromElements(
                  "[data-mega-menu-parent]",
                  "active"
                ),
                this.removeClassFromElements("[data-mega-menu-child]", [
                  "active",
                  "!hidden",
                ]),
                this.removeClassFromElements("[data-submenu-child-container]", [
                  "active",
                  "!hidden",
                ]),
                this.removeClassFromElements("[data-submenu-child]", [
                  "active",
                  "!hidden",
                ]),
                this.removeClassFromElements("[data-submenu-parent]", "active");
            },
          },
          {
            key: "addClassToElements",
            value: function (e, t) {
              document.querySelectorAll(e).forEach(function (e) {
                Array.isArray(t)
                  ? t.forEach(function (t) {
                      return e.classList.add(t);
                    })
                  : e.classList.add(t);
              });
            },
          },
          {
            key: "removeClassFromElements",
            value: function (e, t) {
              document.querySelectorAll(e).forEach(function (e) {
                Array.isArray(t)
                  ? t.forEach(function (t) {
                      return e.classList.remove(t);
                    })
                  : e.classList.remove(t);
              });
            },
          },
          {
            key: "activateFirstMegaMenu",
            value: function () {
              var e = this,
                t = document.querySelector("[data-mega-menu-parent]");
              t &&
                (this.activateElement(t),
                document
                  .querySelectorAll("[data-mega-menu-child]")
                  .forEach(function (n) {
                    if (n.dataset.megaMenuChild !== t.dataset.megaMenuParent)
                      n.classList.remove("active"), n.classList.add("!hidden");
                    else {
                      e.activateElement(n);
                      var a = n.querySelector("[data-submenu-parent]");
                      if (!a) return;
                      e.activateElement(a),
                        n
                          .querySelectorAll("[data-submenu-child-container]")
                          .forEach(function (t) {
                            if (
                              t.dataset.submenuChildContainer !==
                              a.dataset.submenuParent
                            )
                              t.classList.remove("active"),
                                t.classList.add("!hidden");
                            else {
                              e.activateElement(t);
                              var n = t.querySelector("[data-submenu-child]");
                              n && e.activateElement(n);
                            }
                          });
                    }
                  }));
            },
          },
          {
            key: "activateElement",
            value: function (e) {
              e && (e.classList.add("active"), e.classList.remove("!hidden"));
            },
          },
        ]
      );
    })(),
    l = (function () {
      return i(
        function e() {
          a(this, e),
            (this.megaMenuParents = document.querySelectorAll(
              "[data-mega-menu-parent]"
            )),
            (this.megaMenuChildren = document.querySelectorAll(
              "[data-mega-menu-child]"
            )),
            (this.submenuChildren = document.querySelectorAll(
              "[data-submenu-child]"
            )),
            (this.submenuChildContainers = document.querySelectorAll(
              "[data-submenu-child-container]"
            ));
        },
        [
          {
            key: "handleMegaMenuMouseEnter",
            value: function (e) {
              if (e.target.closest && e.target.closest('.a11y-click-mega-menu')) return;
              var t = e.target.dataset.megaMenuParent;
              this.activateElement(e.target),
                this.deactivateAllExceptTarget(this.megaMenuParents, e.target),
                this.hideAndDeactivateElements(this.megaMenuChildren),
                this.hideAndDeactivateElements(this.submenuChildren);
              var n = document.querySelector(
                  "[data-mega-menu-child='".concat(t, "']")
                ),
                a = this.submenuChildContainers[0],
                r = n ? n.querySelector("[data-submenu-child]") : null,
                i = a ? a.dataset.submenuChildContainer : null;
              i &&
                this.activateElement(
                  document.querySelector(
                    "[data-submenu-parent='".concat(i, "']")
                  )
                ),
                this.showAndActivateElement(a),
                this.showAndActivateElement(n),
                this.showAndActivateElement(r);
            },
          },
          {
            key: "activateElement",
            value: function (e) {
              e && e.classList.add("active");
            },
          },
          {
            key: "deactivateElement",
            value: function (e) {
              e && e.classList.remove("active");
            },
          },
          {
            key: "hideAndDeactivateElements",
            value: function (e) {
              var t = this;
              e.forEach(function (e) {
                e.classList.add("!hidden"), t.deactivateElement(e);
              });
            },
          },
          {
            key: "showAndActivateElement",
            value: function (e) {
              e && (e.classList.remove("!hidden"), this.activateElement(e));
            },
          },
          {
            key: "deactivateAllExceptTarget",
            value: function (e, t) {
              var n = this;
              e.forEach(function (e) {
                e !== t && n.deactivateElement(e);
              });
            },
          },
        ]
      );
    })();
  new ((function () {
    return i(
      function e() {
        var t = this;
        a(this, e),
          (this.isMobile = window.matchMedia("(max-width: 1021px)").matches),
          document.addEventListener("DOMContentLoaded", function () {
            t.initialize();
          });
      },
      [
        {
          key: "initialize",
          value: function () {
            var e = this;
            if (
              ((this.lastScrollTop = 0),
              this.setupEventListeners(),
              this.megaMenuEventListeners(),
              this.submenuParentLinkMouseEnterListeners(),
              this.dropdownMenuParentMouseEnterListeners(),
              !this.isMobile)
            ) {
              this.setPageWrapperPaddingTopToHeaderHeight(),
                window.addEventListener("resize", function () {
                  s(this.setPageWrapperPaddingTopToHeaderHeight, 100);
                });
              var t = new MutationObserver(function (t) {
                  t.forEach(function (t) {
                    "class" === t.attributeName &&
                      t.target.classList.contains("swiper-slide") &&
                      e.setPageWrapperPaddingTopToHeaderHeight();
                  });
                }),
                n = document.querySelector(".header-desktop");
              t.observe(n, { attributes: !0, childList: !0, subtree: !0 });
            }
          },
        },
        {
          key: "closeAllDropdownMenus",
          value: function () {
            var e = new c();
            e.resetMenuState(), e.activateFirstMegaMenu();
          },
        },
        {
          key: "megaMenuEventListeners",
          value: function () {
            var e = this;
            try {
              document
                .querySelectorAll("[data-mega-menu-parent]")
                .forEach(function (t) {
                  var n = new l();
                  t.addEventListener(
                    "mouseenter",
                    s(n.handleMegaMenuMouseEnter.bind(n), 100)
                  ),
                    t.addEventListener(
                      "mouseleave",
                      e.handleMegaMenuMouseLeave
                    );
                }),
                document
                  .querySelectorAll('[data-parent-item="not-dropdown"]')
                  .forEach(function (t) {
                    t.addEventListener("mouseenter", e.closeAllDropdownMenus);
                  });
            } catch (e) {
              console.error("Error setting up mega menu event listeners:", e);
            }
          },
        },
        {
          key: "setupEventListeners",
          value: function () {
            try {
              document.addEventListener(
                "rebuy:cart.change",
                this.handleCartChange.bind(this)
              ),
                document.addEventListener(
                  "rebuy.ready",
                  this.handleRebuyReady.bind(this)
                );
            } catch (e) {
              console.error("Error setting up event listeners:", e);
            }
          },
        },
        {
          key: "applyFallbackStyles",
          value: function (e) {
            try {
              var t = document.querySelector(".product-id-".concat(e.id, " a"));
              t &&
                (t.style.background =
                  "linear-gradient(180deg, #F2F2F2 0%, #E0E0E0 100%)");
            } catch (e) {
              console.error("Error applying fallback styles:", e);
            }
          },
        },
        {
          key: "handleRebuyReady",
          value: function (e) {
            var t = this;
            setTimeout(function () {
              try {
                e.detail.widget.data.products.forEach(function (e) {
                  e.metafields.custom
                    ? t.applyCustomStyles(e)
                    : t.applyFallbackStyles(e);
                });
              } catch (e) {
                console.error("Error handling rebuy ready event:", e);
              }
            }, 150);
          },
        },
        {
          key: "applyCustomStyles",
          value: function (t) {
            try {
              return; // dont need this -- sanket
              var n = t.metafields.custom;
              Object.entries(n).forEach(function (n) {
                var a,
                  r,
                  i =
                    ((r = 2),
                    (function (e) {
                      if (Array.isArray(e)) return e;
                    })((a = n)) ||
                      (function (e, t) {
                        var n =
                          null == e
                            ? null
                            : ("undefined" != typeof Symbol &&
                                e[Symbol.iterator]) ||
                              e["@@iterator"];
                        if (null != n) {
                          var a,
                            r,
                            i,
                            o,
                            s = [],
                            c = !0,
                            l = !1;
                          try {
                            if (((i = (n = n.call(e)).next), 0 === t)) {
                              if (Object(n) !== n) return;
                              c = !1;
                            } else
                              for (
                                ;
                                !(c = (a = i.call(n)).done) &&
                                (s.push(a.value), s.length !== t);
                                c = !0
                              );
                          } catch (e) {
                            (l = !0), (r = e);
                          } finally {
                            try {
                              if (
                                !c &&
                                null != n.return &&
                                ((o = n.return()), Object(o) !== o)
                              )
                                return;
                            } finally {
                              if (l) throw r;
                            }
                          }
                          return s;
                        }
                      })(a, r) ||
                      e(a, r) ||
                      (function () {
                        throw new TypeError(
                          "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                        );
                      })()),
                  o = i[0],
                  s = i[1];
                if ("card_background_colors" === o) {
                  var c = s.replace(/[\[\]\"']/g, "").split(","),
                    l = c[0],
                    u = c[1];
                  (l && u) ||
                    console.error("Invalid custom field value:", s, t);
                  var d = "background: linear-gradient(180deg, "
                    .concat(u, " 0%, ")
                    .concat(l, " 100%);");
                  setTimeout(function () {
                    var e = document.querySelector(
                      ".product-id-".concat(t.id, " a")
                    );
                    if (e) {
                      var n = e.getAttribute("style") || "";
                      e.querySelector("img").setAttribute("style", n),
                        e.setAttribute("style", d);
                    }
                  }, 500);
                }
              });
            } catch (e) {
              console.error("Error applying custom styles:", e);
            }
          },
        },
        {
          key: "handleSubmenuParentLinkMouseEnter",
          value: function (e) {
            if (e.target.closest && e.target.closest('.a11y-click-mega-menu')) return;
            var t = e.target.dataset.submenuParent;
            document
              .querySelectorAll("[data-submenu-parent]")
              .forEach(function (e) {
                return e.classList.remove("active");
              }),
              e.target.classList.add("active"),
              e.target.classList.remove("!hidden"),
              document
                .querySelectorAll("[data-submenu-child-container]")
                .forEach(function (e) {
                  e.classList.add("!hidden"), e.classList.remove("active");
                });
            var n = document.querySelector(
              "[data-submenu-child-container='".concat(t, "']")
            );
            n &&
              (n.classList.remove("!hidden"),
              n.classList.add("active"),
              n.querySelectorAll("[data-submenu-child]").forEach(function (e) {
                e.classList.remove("!hidden"), e.classList.add("active");
              }));
          },
        },
        {
          key: "onDropdownMenuParentMouseEnter",
          value: function (e) {
            if (e.target.closest && e.target.closest('.a11y-click-mega-menu')) return;
            document.querySelectorAll(".dropdown-menu").forEach(function (e) {
              e.classList.remove("active");
            }),
              e.target.classList.add("active"),
              e.target
                .querySelector(".header__mega-menu")
                .classList.remove("!hidden"),
              document
                .querySelectorAll(".header__mega-menu")
                .forEach(function (t) {
                  t !== e.target.querySelector(".header__mega-menu") &&
                    (t.classList.add("!hidden"), t.classList.remove("active"));
                });
          },
        },
        {
          key: "dropdownMenuParentMouseEnterListeners",
          value: function () {
            var e = this;
            document.querySelectorAll(".dropdown-menu").forEach(function (t) {
              var n = new c();
              t.addEventListener(
                "mouseenter",
                e.onDropdownMenuParentMouseEnter
              ),
                t.addEventListener(
                  "mouseleave",
                  n.onDropdownMenuParentMouseLeave.bind(n)
                );
            });
          },
        },
        {
          key: "submenuParentLinkMouseEnterListeners",
          value: function () {
            var e = this;
            try {
              document
                .querySelectorAll("[data-submenu-parent]")
                .forEach(function (t) {
                  t.addEventListener(
                    "mouseenter",
                    e.handleSubmenuParentLinkMouseEnter
                  );
                });
            } catch (e) {
              console.error(
                "Error setting up submenu parent link mouse enter listeners:",
                e
              );
            }
          },
        },
        {
          key: "handleCartChange",
          value: function (e) {
            try {
              var t = e.detail.cart.itemCount(),
                n = t > 0;
              this.toggleElementVisibility(".cart-icon--empty", !n),
                this.toggleElementVisibility(".cart-icon--filled", n),
                this.toggleElementVisibility("[js-cart-count]", n),
                n && this.updateCartCount(t);
            } catch (e) {
              console.error("Error handling cart change:", e);
            }
          },
        },
        {
          key: "toggleElementVisibility",
          value: function (e, t) {
            try {
              var n = document.querySelector(e);
              n && n.classList.toggle("hidden", !t);
            } catch (t) {
              console.error("Error toggling visibility for ".concat(e, ":"), t);
            }
          },
        },
        {
          key: "updateCartCount",
          value: function (e) {
            try {
              var t = document.querySelector("[js-cart-count]");
              t && (t.textContent = "(".concat(e, ")"));
            } catch (e) {
              console.error("Error updating cart count:", e);
            }
          },
        },
        {
          key: "setPageWrapperPaddingTopToHeaderHeight",
          value: function () {
            if (window.matchMedia("(max-width: 1021px)").matches) {
              var e = document.querySelector(".page-wrapper");
              if (e && 0 == document.body.classList.contains("blog"))
                e.style.paddingTop = "0px";
              else if (e && document.body.classList.contains("blog")) {
                var t = document.querySelector(
                  "header:not(.mobile_nav-fixed--true) .header"
                );
                e.style.paddingTop = "".concat(t.offsetHeight, "px");
              }
            } else
              try {
                var n = document.querySelector(
                  "header:not(.mobile_nav-fixed--true) .header"
                );
                if (n) {
                  var a = document.querySelector(".page-wrapper");
                  a && (a.style.paddingTop = "".concat(n.offsetHeight, "px"));
                }
              } catch (e) {
                console.error("Error setting page wrapper padding:", e);
              }
          },
        },
      ]
    );
  })())();
  var u = (function () {
    return i(
      function e() {
        a(this, e),
          (this.mobileMenuDropdown = document.querySelector(
            '[data-dropdown="menu"]'
          )),
          (this.mobileHeader = document.querySelector("#header"));
      },
      [
        {
          key: "initialize",
          value: function () {
            this.getMobileHeaderHeight(), this.setupEventListeners();
          },
        },
        {
          key: "getMobileHeaderHeight",
          value: function () {
            var e = this.mobileHeader.offsetHeight;
            this.mobileMenuDropdown.style.setProperty(
              "--dynamic-top",
              "".concat(e, "px")
            ),
              this.mobileMenuDropdown.classList.add("dynamic-top"),
              (this.mobileMenuDropdown.style.height = "calc(100vh - ".concat(
                e,
                "px)"
              ));
          },
        },
        {
          key: "handleMobileMegaMenuLastSubClick",
          value: function (e) {
            e.preventDefault();
            var t = e.target;
            t.classList.toggle("active"), t.classList.toggle("open");
            var n = t.closest("[data-mobile-mega-menu-lastsub]");
            document
              .querySelector(
                '[data-mobile-mega-menu-lastsub-dropdown="'.concat(
                  n.dataset.mobileMegaMenuLastsub,
                  '"]'
                )
              )
              .classList.toggle("!block");
          },
        },
        {
          key: "setupEventListeners",
          value: function () {
            var n,
              a = this;
            ((n = document.querySelectorAll("[data-mobile-mega-menu-lastsub]")),
            (function (e) {
              if (Array.isArray(e)) return t(e);
            })(n) ||
              (function (e) {
                if (
                  ("undefined" != typeof Symbol &&
                    null != e[Symbol.iterator]) ||
                  null != e["@@iterator"]
                )
                  return Array.from(e);
              })(n) ||
              e(n) ||
              (function () {
                throw new TypeError(
                  "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                );
              })()).forEach(function (e) {
                  //e.addEventListener("click", a.handleMobileMegaMenuLastSubClick); // sanket comment for mobile menu work - 3rd level
            });
          },
        },
      ]
    );
  })();
  document.addEventListener("DOMContentLoaded", function () {
    new u().initialize();
  });
  var d = (function () {
    return i(
      function e() {
        a(this, e),
          (this.lastScrollTop = 0),
          (this.placeholder = null),
          (this.initialFixed = !1),
          (this.checkScreenSize = this.checkScreenSize.bind(this)),
          (this.toggleFixedClass = this.toggleFixedClass.bind(this)),
          window.addEventListener("resize", this.checkScreenSize),
          this.checkScreenSize();
      },
      [
        {
          key: "createPlaceholder",
          value: function (e) {
            (this.placeholder = document.createElement("div")),
              (this.placeholder.style.height = "".concat(e.offsetHeight, "px")),
              e.parentNode.insertBefore(this.placeholder, e.nextSibling);
          },
        },
        {
          key: "removePlaceholder",
          value: function () {
            this.placeholder &&
              (this.placeholder.parentNode.removeChild(this.placeholder),
              (this.placeholder = null));
          },
        },
        {
          key: "toggleFixedClass",
          value: function () {
            var e = document.querySelector("#header.mobile_nav-fixed--true");
            if (e) {
              var t = window.scrollY;
              t > e.offsetHeight && t > this.lastScrollTop
                ? (e.classList.contains("fixed") ||
                    (this.createPlaceholder(e),
                    this.initialFixed ||
                      (e.classList.add("initial-slide"),
                      (this.initialFixed = !0)),
                    e.classList.add("fixed"),
                    setTimeout(function () {
                      e.classList.remove("initial-slide");
                    }, 400)),
                  e.classList.add("visible"),
                  document.body.classList.add("fixed-header"))
                : t <= this.lastScrollTop &&
                  (e.classList.remove("visible"),
                  document.body.classList.remove("fixed-header"),
                  t <= e.offsetHeight &&
                    (e.classList.remove("fixed"), this.removePlaceholder())),
                (this.lastScrollTop = t <= 0 ? 0 : t);
            }
          },
        },
        {
          key: "checkScreenSize",
          value: function () {
            if (window.innerWidth < 1024)
              window.addEventListener("scroll", s(this.toggleFixedClass, 100)),
                this.toggleFixedClass();
            else {
              window.removeEventListener("scroll", this.toggleFixedClass);
              var e = document.querySelector("#header.mobile_nav-fixed--true");
              e &&
                (e.classList.remove("fixed"),
                e.classList.remove("visible"),
                e.classList.remove("initial-slide")),
                document.body.classList.remove("fixed-header"),
                this.removePlaceholder(),
                (this.initialFixed = !1);
            }
          },
        },
      ]
    );
  })();
  document.addEventListener("DOMContentLoaded", function () {
    new d();
  }),
    window.addEventListener("rebuy:smartcart.showed", function (e) {
      e.detail.cartCount > 0
        ? (document.querySelectorAll(".cart-icon--empty").forEach(function (e) {
            return e.classList.add("hidden");
          }),
          document.querySelectorAll(".cart-icon--filled").forEach(function (e) {
            return e.classList.remove("hidden");
          }),
          document.querySelectorAll(".cart-count").forEach(function (t) {
            (t.innerHTML = "(".concat(e.detail.cartCount, ")")),
              t.classList.remove("hidden");
          }))
        : (document.querySelectorAll(".cart-icon--empty").forEach(function (e) {
            return e.classList.remove("hidden");
          }),
          document.querySelectorAll(".cart-icon--filled").forEach(function (e) {
            return e.classList.add("hidden");
          }),
          document.querySelectorAll(".cart-count").forEach(function (t) {
            (t.innerHTML = "(".concat(e.detail.cartCount, ")")),
              t.classList.add("hidden");
          }));
    });
})();
